// @ts-expect-error: Moment doesn't have types for its locales
import 'moment/locale/es';
// @ts-expect-error: Moment doesn't have types for its locales
import 'moment/locale/pt';
// @ts-expect-error: Moment doesn't have types for its locales
import 'moment/locale/zh-cn';
// @ts-expect-error: Moment doesn't have types for its locales
import 'moment/locale/ru';
// @ts-expect-error: Moment doesn't have types for its locales
import 'moment/locale/vi';
// @ts-expect-error: Moment doesn't have types for its locales
import 'moment/locale/ar';
// @ts-expect-error: Moment doesn't have types for its locales
import 'moment/locale/zh-tw';
// @ts-expect-error: Moment doesn't have types for its locales
import 'moment/locale/tl-ph';
// @ts-expect-error: Moment doesn't have types for its locales
import 'moment/locale/ko';

import { MOMENT_LOCALE_NAMES, usePreferredLocale } from '@color/lib';
import moment from 'moment';
import { useEffect } from 'react';

/**
 * @deprecated
 * FIXME: Do not use this. We are migrating away from moment and to date-fns.
 * This does not live in @color/i18n because we do not want to bring in moment.
 * https://getcolor.atlassian.net/browse/UITASK-149
 */
export const useDeprecatedMomentLocale = () => {
  const { locale } = usePreferredLocale();
  const shortLocaleName = MOMENT_LOCALE_NAMES[locale];

  /**
   * `useEffect` is often dangerous and unnecessary. This usage needs review by #ux-programs team.
   * See https://getcolor.atlassian.net/browse/UXTASK-1406
   */
  // nosemgrep:semgrep-rules.ui-useEffect
  useEffect(() => {
    moment.locale(shortLocaleName);
  }, [shortLocaleName]);
};
